// Guest access to Copilot conversations.
//
// A guest has no account: the only credential is the per-conversation token
// the backend returns once (valid 14 days after the last use, opens that one
// conversation only). To let a guest come back, the tokens of their
// conversations are kept in this browser's localStorage - nowhere else, never
// in a URL, never logged. Trade-off: anything running on the page could read
// them, so they are scoped (one conversation each), expiring, and removed as
// soon as the backend says they no longer work, and when the user signs in.
//
// Entry: { id, token, reference, subject, createdAt }

const KEY = "lud-copilot-guest-v1";
const MAX_ENTRIES = 10;

const read = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(parsed)
      ? parsed.filter((e) => e && typeof e.id === "string" && typeof e.token === "string")
      : [];
  } catch {
    return [];
  }
};

// Fallback used only when storage cannot be written (private mode): the guest
// then keeps access for this page load only. Otherwise storage is always the
// source of truth, so other tabs' changes are seen.
let memory = null;
const write = (entries) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(entries.slice(0, MAX_ENTRIES)));
    memory = null;
  } catch {
    memory = entries.slice(0, MAX_ENTRIES);
  }
};
const load = () => memory || read();

export function listGuestConversations() {
  return load();
}

export function getGuestToken(id) {
  return load().find((e) => e.id === id)?.token || null;
}

export function saveGuestConversation(entry) {
  write([entry, ...load().filter((e) => e.id !== entry.id)]);
}

export function removeGuestConversation(id) {
  write(load().filter((e) => e.id !== id));
}

export function clearGuestConversations() {
  memory = null;
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}

// Only for tests.
export function resetGuestStoreMemory() {
  memory = null;
}
